import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const DELETE_EMOTION_CATEGORY_MUTATION = gql`
    mutation DeleteEmotionCategory($uid: String!) {
      emotion_category_delete(uid: $uid) {
            success
        }
    }
`;

export async function deleteEmotionCategory(uid: string): Promise<{ success: boolean }> {
  const result: FetchResult<{ emotion_category_delete: { success: boolean } }> = await graphqlClient.mutate({
      mutation: DELETE_EMOTION_CATEGORY_MUTATION,
      variables: { uid },
      errorPolicy: 'all',
  });

  if (!result.data || (result.errors && result.errors.length)) {
      throw new MultiError(result.errors || ['Unknown error']);
  }

  return {
    success: result.data.emotion_category_delete.success,
  };
}
